import { Badge, Box, Button, Container, Grid } from '@mui/material'
import React from 'react'
import headerLogo from '../../../assets/images/logo.svg'
import Login from '../../auth/login/login';
import HeaderSearch from './headerSearch';
import HeaderCartImage from '../../../assets/images/headerCart.svg'
import { Link, useNavigate } from 'react-router-dom';
import ProfileMenu from './profileButton';
import { fetchProfile } from '../../../reduxState/customerProfile/profileList';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../reduxState/store';
import { fetchCarts } from '../../../reduxState/cartSlice/cartGetallSlice';
import Otp from '../../auth/login/otp';
import SignUp from '../../auth/login/signUp';

const Header: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [isOtpModalOpen, setIsOtpModalOpen] = React.useState(false);
  const [isSignUpModalOpen, setIsSignUpodalOpen] = React.useState(false);
  const navigate = useNavigate()
  const token = localStorage.getItem('AUTH_TOKEN')
  const dispatch = useDispatch<AppDispatch>();
  const products = useSelector((state: RootState) => state.profileList.data);
  const profileUpdate = useSelector((state: RootState) => state.profileUpdate);
  const cartCount = useSelector((state: RootState) => state.cartList);

  React.useEffect(() => {
    if (token) {
    dispatch(fetchProfile(''));
      dispatch(fetchCarts({ status: 'ACTIVE' }))
    }
  }, [token, profileUpdate.code && profileUpdate.loading]);

  // login model open and close
  const handleLoginModalOpen = () => {
    setIsModalOpen(true);
  };

  const handleLoginModalClose = (event: React.MouseEvent<HTMLButtonElement>, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setIsModalOpen(false);
    }
  };

  const handleOtpModalClose = (event: React.MouseEvent<HTMLButtonElement>, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setIsOtpModalOpen(false);
    }
  };

  const handleSignUpModalClose = (event: React.MouseEvent<HTMLButtonElement>, reason: "backdropClick" | "escapeKeyDown") => {
    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
      setIsSignUpodalOpen(false)
    }
  };

  const handleCartPage = () => {
    navigate("/product-cart/list")
  }

  return (
    <Box className='bg-head' position={'sticky'} top={'0'} zIndex={2}>
      <Container>
        <Grid container py={3} alignItems={'center'} justifyContent={'space-between'}>
          <Grid item order={{ xs: 1 }} xs={6} sm={2.5} lg={2.5}>
            <Link to="/homepage"><img src={headerLogo} alt="logo" className='headerLogo' loading='lazy' /></Link>
          </Grid>
          <Grid item order={{ xs: 3, sm:2 }} xs={12} sm={6.75} lg={6.75} mt={{xs:1, sm:0}}>
            <HeaderSearch />
          </Grid>
          <Grid item order={{ xs: 2, sm:3 }} xs={6} sm={2.25} lg={2.25} display={'flex'} justifyContent={token ? 'space-between' : 'end'}>
            {token ? 
            <Box>
            <Badge badgeContent={cartCount.count} className='badge-color' color="warning">
              <Button variant="contained" className='cart-button' onClick={handleCartPage}>
                    <img src={HeaderCartImage} alt="Cart Icon" loading='lazy' />
              </Button>
            </Badge> 
              </Box> : ('')}
            {token ? <ProfileMenu name={products?.firstName} image={products?.profile} /> :
              <Button variant="contained" size="large" sx={{ width: '45%' }} className='login-button reem-kulfi' onClick={handleLoginModalOpen}>Login</Button>
            }
            <Login isOpen={isModalOpen} onClose={handleLoginModalClose} setIsOtpModalOpen={setIsOtpModalOpen} setIsSignUpodalOpen={setIsSignUpodalOpen} />
            <Otp isOpen={isOtpModalOpen} onOtpClose={handleOtpModalClose} />
            <SignUp isOpen={isSignUpModalOpen} onSignUpClose={handleSignUpModalClose} setIsModalOpen={setIsModalOpen} setIsOtpModalOpen={setIsOtpModalOpen}/>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default Header